import React from 'react';

const PaperboyWordmark = ({ size = 20, accent = '#2563eb' }) => (
  <div className="wordmark" style={{ '--wm-size': `${size}px`, '--wm-size-lg': `${size * 1.25}px`, '--wm-accent': accent }}>
    <span className="wordmark__bracket">[</span>
    <span className="wordmark__text">paperboy</span>
    <span className="wordmark__bracket">]</span>
  </div>
);

export default PaperboyWordmark;
